import { DOCUMENT } from '@angular/common';
import { EventEmitter, Inject, Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { StorageService } from '../../../../core/services/storage.service';

@Injectable({ providedIn: 'root' })
export class SocialAuthService {
  googleOnSignedIn = new EventEmitter();
  private window: Window | any;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private storage: StorageService,
  ) {
    this.window = this.document.defaultView as Window;
  }

  public async initGoogleSDK() {
    const skdJsElementId = 'google-jssdk';
    if (this.document.getElementById(skdJsElementId)) {
      this.initialize();
      return;
    }

    const script = this.document.createElement('script') as HTMLScriptElement;
    script.id = skdJsElementId;
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    this.document.body.insertAdjacentElement('beforeend', script);

    var intrv = setInterval(() => {
      if (this.window?.google?.accounts?.id) {
        this.initialize();
        clearInterval(intrv);
      }
    }, 1000);
  }

  initialize() {
    this.window.google.accounts.id.initialize({
      client_id: environment.google.client_id,
      // ux_mode: "redirect",
      // cancel_on_tap_outside: false,
      //   prompt_parent_id
      locale: this.storage.i18n.value,
      auto_select: false,
      itp_support: true,
      use_fedcm_for_prompt: true,
      callback: (result: any) => {
        this.googleOnSignedIn.next(result);
      },
    });

    this.window.google.accounts.id.renderButton(
      document.getElementById('loginByGoogleBtn'),
      {
        locale: this.storage.i18n.value,

        size: 'large',
        theme: 'outline',
        type: 'standard',
        shape: 'pill',
        width: '500',
        height: '300',
      },
    );
    this.window.google.accounts.id.prompt();
  }
}
